module.exports = __webpack_public_path__ + "static/media/round-button-primary.e92415dd.svg";